(function($) {
    $.fn.embedLogin = function (options) {
        options = $.extend({
            url: 'about:blank'
        }, options);

        this.each(function() {

            const $button = $(this);

            $button.on('click', function(){
                window.open(options.url, '_blank', 'width=500, height=660, menubar=no, toolbar=no, scrollbars=yes');
            });

        });
    };
})(jQuery);
